import Vue from "vue";

// mdc components (form matsp)
// import Button from "material-components-vue/dist/button";
// import Card from "material-components-vue/dist/card";
// import Chips from "material-components-vue/dist/chips";
// import Drawer from "material-components-vue/dist/drawer";
// import Dialog from "material-components-vue/dist/dialog";
// import Elevation from "material-components-vue/dist/elevation";
// import FloatingLabel from "material-components-vue/dist/floating-label";
// import Icon from "material-components-vue/dist/icon";
// import IconButton from "material-components-vue/dist/icon-button";
// import LayoutGrid from "material-components-vue/dist/layout-grid";
// import LineRipple from "material-components-vue/dist/line-ripple";
// import List from "material-components-vue/dist/list";
// import NotchedOutline from "material-components-vue/dist/notched-outline";
// import Select from "material-components-vue/dist/select";
// import Switch from "material-components-vue/dist/switch";
// import Tabs from "material-components-vue/dist/tabs";
// import TextField from "material-components-vue/dist/text-field";
// import TopAppBar from "material-components-vue/dist/top-app-bar";
// import Typography from "material-components-vue/dist/typography";

import Button from "./material-components-vue/button";
import Card from "./material-components-vue/card";
import Checkbox from "././material-components-vue/checkbox";
import Chips from "./material-components-vue/chips";
import Drawer from "./material-components-vue/drawer";
import Dialog from "./material-components-vue/dialog";
import Elevation from "./material-components-vue/elevation";
import FloatingLabel from "./material-components-vue/floating-label";
import Icon from "./material-components-vue/icon";
import IconButton from "./material-components-vue/icon-button";
import LayoutGrid from "./material-components-vue/layout-grid";
import LineRipple from "./material-components-vue/line-ripple";
import List from "./material-components-vue/list";
import NotchedOutline from "./material-components-vue/notched-outline";
import Select from "./material-components-vue/select";
import Switch from "./material-components-vue/switch";
import Tabs from "./material-components-vue/tabs";
import TextField from "./material-components-vue/text-field";
import TopAppBar from "./material-components-vue/top-app-bar";
import Typography from "./material-components-vue/typography";

// Vue material app
import dataAccess from "./dataAccess/dataAccess.js";
import loglevel from "loglevel";
import utils from "./utils.js";

const options = {
  Button,
  Card,
  Checkbox,
  Chips,
  Drawer,
  Dialog,
  Elevation,
  FloatingLabel,
  Icon,
  IconButton,
  LayoutGrid,
  LineRipple,
  List,
  NotchedOutline,
  Select,
  Switch,
  Tabs,
  TextField,
  TopAppBar,
  Typography
};

options.install = Vue => {
  for (let component in options) {
    const componentInstaller = options[component];

    if (componentInstaller && component !== "install") {
      Vue.use(componentInstaller);
    }
  }
};

// Facilitamos el acceso a funcionalidad común del framework para que se use desde la propia instancia de cada
// componente
Vue.prototype.$mdApp = new Vue({
  data: {
    dataAccess: dataAccess, // acceso a datos
    log: loglevel, // funciones de logs, se inicializa en mdApp, inicalmente tal como loglevel (después se añadirán más cosas)
    utils: utils // funciones de utilidad y comunes
  }
});

export default options;

// Copied from old vue-material-app
// import MdCore from './core';
// import MdAvatar from './components/mdAvatar';
// import MdBackdrop from './components/mdBackdrop';
// import MdBottomBar from './components/mdBottomBar';
// import MdButton from './components/mdButton';
// import MdButtonToggle from './components/mdButtonToggle';
// import MdCard from './components/mdCard';
// import MdCheckbox from './components/mdCheckbox';
// import MdChips from './components/mdChips';
// import MdDialog from './components/mdDialog';
// import MdDivider from './components/mdDivider';
// import MdFile from './components/mdFile';
// import MdIcon from './components/mdIcon';
// import MdImage from './components/mdImage';
// import MdInputContainer from './components/mdInputContainer';
// import MdLayout from './components/mdLayout';
// import MdList from './components/mdList';
// import MdMenu from './components/mdMenu';
// import MdOnboarding from './components/mdOnboarding';
// import MdProgress from './components/mdProgress';
// import MdRadio from './components/mdRadio';
// import MdRatingBar from './components/mdRatingBar';
// import MdSelect from './components/mdSelect';
// import MdSidenav from './components/mdSidenav';
// import MdSnackbar from './components/mdSnackbar';
// import MdSpeedDial from './components/mdSpeedDial';
// import MdSpinner from './components/mdSpinner';
// import MdStepper from './components/mdStepper';
// import MdSubheader from './components/mdSubheader';
// import MdSwitch from './components/mdSwitch';
// import MdTable from './components/mdTable';
// import MdTabs from './components/mdTabs';
// import MdToolbar from './components/mdToolbar';
// import MdTooltip from './components/mdTooltip';
// import MdWhiteframe from './components/mdWhiteframe';

// // vuematerialapp added components
// import mdApp from './components-vuematerialapp/mdApp';
// import mdInputSearch from './components-vuematerialapp/mdInputSearch';
// import mdContent from './components-vuematerialapp/mdContent';
// import mdContentCmspage from './components-vuematerialapp/mdContentCmspage';
// import mdContentDatalist from './components-vuematerialapp/mdContentDatalist';
// import mdContentDatadetail from './components-vuematerialapp/mdContentDatadetail';
// import mdTextSection from './components-vuematerialapp/mdTextSection';
// import mdImg from './components-vuematerialapp/mdImg';
// import MdProgressOverlay from './components-vuematerialapp/mdProgressOverlay';
// import dataAccess from './components-vuematerialapp/dataAccess/dataAccess.js';
// import utils from './components-vuematerialapp/utils.js';
// import mdCms from './components-vuematerialapp/mdCms';
// import aditionalFormattersMixin from './components-vuematerialapp/aditionalFormattersMixin';
// import log from 'loglevel';

// const options = {
//   MdCore,
//   MdAvatar,
//   MdBackdrop,
//   MdBottomBar,
//   MdButton,
//   MdButtonToggle,
//   MdCard,
//   MdCheckbox,
//   MdChips,
//   MdDialog,
//   MdDivider,
//   MdFile,
//   MdIcon,
//   MdImage,
//   MdInputContainer,
//   MdLayout,
//   MdList,
//   MdMenu,
//   MdOnboarding,
//   MdProgress,
//   MdRadio,
//   MdRatingBar,
//   MdSelect,
//   MdSidenav,
//   MdSnackbar,
//   MdSpeedDial,
//   MdSpinner,
//   MdStepper,
//   MdSubheader,
//   MdSwitch,
//   MdTable,
//   MdTabs,
//   MdToolbar,
//   MdTooltip,
//   MdWhiteframe,
//   // vuematerialapp components added
//   mdApp,
//   mdCms,
//   mdContent,
//   mdContentCmspage,
//   mdContentDatalist,
//   mdContentDatadetail,
//   mdImg,
//   mdInputSearch,
//   mdTextSection,
//   MdProgressOverlay
// };

// options.install = (Vue) => {
//   for (let component in options) {
//     const componentInstaller = options[component];

//     if (componentInstaller && component !== 'install') {
//       Vue.use(componentInstaller);
//     }
//   }

//   // Facilitamos el acceso a funcionalidad común del framework para que se use desde la propia instancia de cada
//   // componente
//   Vue.prototype.$mdApp = new Vue({
//     data: {
//       dataAccess: dataAccess, // acceso a datos
//       utils: utils, // funciones de utilidad y comunes
//       log: log, // funciones de logs, se inicializa en mdApp, inicalmente tal como loglevel (después se añadirán más cosas)
//       userNotification: {
//         showOperationSuccessMsg: null // Se actualiza después en mdApp
//       },
//       validationMsgs: {
//         required: 'Es obligatorio',
//         email: 'Debe tener un formato de email',
//         numeric: 'Es numérico',
//         alpha: 'Debe tener solo letras'
//       }
//     }
//   });

//   // Añadimos los mixins
//   Vue.mixin(aditionalFormattersMixin);
// };
